import { Form } from "react-bootstrap";

const MonthYearPicker = ({ label, value, setValue, formClass, style }) => {
  // Convert MMYYYY to YYYY-MM for input display
  const inputValue =
    value.length === 6
      ? `${value.slice(2)}-${value.slice(0, 2)}`
      : ""; // fallback if format is unexpected

  const handleChange = (e) => {
    const [year, month] = e.target.value.split("-");
    setValue(`${month}${year}`); // set as MMYYYY
  };

  return (
    <Form.Group
      className={formClass ? formClass : "form-inline"}
      controlId="monthYear"
      style={style}
    >
      <Form.Control
        type="month"
        value={inputValue}
        onChange={handleChange}
        size="sm"
        style={{ width: "100%", fontSize: 13 }}
      />
    </Form.Group>
  );
};

export default MonthYearPicker;
